import { useQuery } from "@tanstack/react-query";
import { api, call } from "./api.ts";
import { setTripTypeLabels } from "./trip-types.ts";

export const TRIP_TYPE_LABELS_KEY = ["trip-types", "labels"] as const;
const loadLabels = () => call(api.admin["trip-types"].labels.get());

/**
 * Loads the names once for the whole admin (the shell waits for it), so `typeLabel` works in
 * render code and plain helpers alike. Invalidate `TRIP_TYPE_LABELS_KEY` after editing types.
 */
export function useTripTypeLabels() {
  const q = useQuery({ queryKey: TRIP_TYPE_LABELS_KEY, queryFn: loadLabels, staleTime: 5 * 60_000 });
  if (q.data) setTripTypeLabels(q.data);
  return q;
}
